import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import classes from './InternationalTupleRoundTrip.scss';

import InternationTupleDetails from './InternationalTupleDetails/InternationalTupleDetails';
import AirlineLogo from '../Airline/AirlineLogo/AirlineLogo';

import Button from '../../UI/Button/Button';
import * as farePriceActions from '../../../store/actions/index';
import * as stackFlightActions from '../../../store/actions/index';
import * as uiActions from '../../../store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import FlightDetailsRoundTrip from '../../Flight/FlightDetailsRoundTrip/FlightDetailsRoundTrip';
import AgencySummary from '../AgencySummary/AgencySummary';
// import AnimakitExpander from 'animakit-expander';
// import Deal from '../../UI/Deal/Deal';


class InternationalTupleRoundTrip extends Component {

    state = {
        isDepartTupleExpanded: false,
        isReturnTupleExpanded: false,
        isAgencySummaryVisible: false
    }

    openAgencyFareSummary = () => this.setState({ isAgencyFareSummaryVisible: true })
    closeAgencyFareSummary = () => this.setState({ isAgencyFareSummaryVisible: false })

    proceedToBook = e => {
        e.stopPropagation();
        this.props.onClearPax();
        this.props.onSetStackFlight([this.props.intDepart[this.props.tupleIndex][0]], this.props.intDepart[this.props.tupleIndex][0].FD.O, this.props.date, this.props.intDepart[this.props.tupleIndex][0].xmlKey, this.props.intDepart[this.props.tupleIndex][0].ID, "onward");
        this.props.onSetStackFlight([this.props.intReturn[this.props.tupleIndex][0]], this.props.intReturn[this.props.tupleIndex][0].FD.O, this.props.date, this.props.intReturn[this.props.tupleIndex][0].xmlKey, this.props.intReturn[this.props.tupleIndex][0].ID, "return");
        let flightIdCSV = null;
        let flightCode = null;
        let supplierCode = null;
    
        const flightTotalPrice = Math.round(this.props.intDepart[this.props.tupleIndex][0].FD.O.revisedFareDetails.af);
        flightIdCSV = this.props.intDepart[this.props.tupleIndex][0].ID;
        flightCode = this.props.flightCode;
        supplierCode = this.props.intDepart[this.props.tupleIndex][0].xmlKey;
        
    
        const queryParams = [];
        queryParams.push('searchId=' + this.props.searchId);
        queryParams.push('msid=' + this.props.searchId);
        queryParams.push('mode=Instant');
        queryParams.push('bpc=true');
        queryParams.push('isSR=false');
        queryParams.push('flightIdCSV=' + flightIdCSV);
        queryParams.push('flightPrice=' + flightTotalPrice);
        queryParams.push('sc=' + supplierCode);
        queryParams.push('flightCode=' + flightCode);
        queryParams.push('isInt=' + true);
        const queryString = queryParams.join("&");
    
        this.props.history.push({
        //   pathname: "/reviews",
        pathname: "/reviews/details",
          search: "?" + queryString
        });
      };
    
    expandTupleHandler = (type, index) => {
        if (type === 'depart') {
            this.setState(prevState => ({
                isDepartTupleExpanded: !prevState.isDepartTupleExpanded
              }), () => {
                this.props.resize();
              });          
        } else  {
            this.setState(prevState => ({
                isReturnTupleExpanded: !prevState.isReturnTupleExpanded
              }), () => {
                this.props.resize();
              });          
        }
    }

    render() {
        const classTypeDepart = this.props.intDepartFlights[0].classtype;
        const airlineCode = this.props.intDepartFlights[0].FS[0].ac;
        const airlineName = this.props.airlineNames[airlineCode];
        const airlineFare = Math.round(parseInt(this.props.intDepartFlights[0].FD.O.revisedFareDetails.tf, 10)).toLocaleString();
        const colorDark = "var(--color-grey-dark-1)";
        return (
            <div style={{marginBottom: this.state.isDetailExpanded && window.width < 600 ? '0' : '1.5rem'}} className={classes.Tuple}>
                <div className={classes.ContainerPrimary}>
                    <div className={`u-lineHeight1`}>
                        <div className={`u-flex u-phone-width100Percent`}>
                            <AirlineLogo airlineCode={airlineCode} />
                            <div>
                                <span className={`u-fontSize13 u-textColorDark u-block mb-1 u-lineHeight13`}>{airlineName}</span>
                                <span className={`u-textColorLight u-fontWeightRegular u-fontSize13 u-phoneHide u-block`}>{classTypeDepart}</span>    
                            </div>
                        </div>
                    </div>
                    <div onClick={this.proceedToBook} className={`u-phoneShow u-block u-textColorPrimary u-fontSize16 u-fontWeightMedium u-textAlignRight`}>
                        &#8377;{airlineFare}
                        {this.props.showAgentProfit ? <p className="u-fontSize11 u-fontWeightRegular u-textColorNormal u-phoneShow"><span>&#8377;{Math.round(this.props.intDepartFlights[0].FD.O.revisedFareDetails.commision)}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.intDepartFlights[0].FD.O.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                    </div>
                    {/* <div className={`u-flex f-column align-items-start u-fontSize11 u-textColorLight u-phoneHide`}>
                        <div className={`mb-1`}><Deal/></div>
                        <span className={`u-lineHeight15`}>Exclusive unlimited date change benefits.</span>
                    </div> */}
                </div>
                <div className={classes.ContainerSecondary}>
                    <InternationTupleDetails 
                        type={'depart'} 
                        tupleIndex={this.props.tupleIndex} 
                        flightSelect={this.flightSelectHandler} 
                        flight={this.state.departSelectedFlight} 
                        expandTupleHandler={this.expandTupleHandler}
                        isExpanded={this.state.isDepartTupleExpanded}
                        intDepartFlights={this.props.intDepartFlights}
                        onwardLength={this.props.intDepartFlights.length}
                        origin={this.props.origin}
                        destination={this.props.destination}
                        cityNames={this.props.cityNames}
                        date={this.props.date}
                        departFid={this.props.intDepartFlights[0].ID}
                        returnFid={this.props.intReturnFlights[0].ID}/>
                    <div className={classes.HorizontalDivider}></div>
                    <InternationTupleDetails 
                        type={'return'} 
                        tupleIndex={this.props.tupleIndex} 
                        flightSelect={this.flightSelectHandler} 
                        flight={this.state.returnSelectedFlight} 
                        expandTupleHandler={this.expandTupleHandler}
                        isExpanded={this.state.isReturnTupleExpanded}
                        intReturnFlights={this.props.intReturnFlights}
                        returnLength={this.props.intReturnFlights.length}
                        origin={this.props.origin}
                        destination={this.props.destination}
                        cityNames={this.props.cityNames}
                        date={this.props.date}
                        departFid={this.props.intDepartFlights[0].ID}
                        returnFid={this.props.intReturnFlights[0].ID}/>
                </div>
                <div className={classes.Divider}></div>
                <div className={classes.HorizontalLine}></div>
                <div className={classes.ContainerTertiary}>
                    {/* <div className={`u-flex f-column align-items-start u-fontSize11 u-textColorLight u-phoneShow`}>
                        <div className={`mb-1 phone-mb-0`}><Deal/></div>
                        <span className={`u-lineHeight15`}>Exclusive unlimited date change benefits.</span>
                    </div> */}
                    <div className={`u-phoneHide u-fontSize20 u-textColorDark u-height30`} onMouseEnter={() => this.openAgencyFareSummary()} onMouseLeave={() => this.closeAgencyFareSummary()}>
                        {this.state.isAgencyFareSummaryVisible ? <AgencySummary fareDetails={this.props.intDepartFlights[0].FD.O}/> : null}
                        <div>
                            &#8377;{airlineFare}
                        </div>
                        {this.props.showAgentProfit ? <p className="u-fontSize13 u-fontWeightRegular u-textColorNormal"><span>&#8377;{Math.round(this.props.intDepartFlights[0].FD.O.revisedFareDetails.commision)}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.intDepartFlights[0].FD.O.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                    </div>
                    <Button onClick={this.proceedToBook} theme='Primary' width='Block' type='BookSmall'>Book</Button>
                    <div className={`${classes.Details} u-fontSize11 u-textColorDark u-cursorPointer u-textUppercase`} onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        this.props.onToggleMobileFlightDetail();
                        this.props.onSetIntIds(this.props.intDepartFlights[0].ID, this.props.intReturnFlights[0].ID, this.props.tupleIndex);}}>Details <span style={{marginLeft: '2px'}}><FontAwesomeIcon icon="caret-right" color={'currentColor'} size="1x" /></span></div>
                </div>            
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        airlineNames: state.flights.airlineNames,
        intDepart: state.flights.int.intRoundTripDepart,
        intReturn: state.flights.int.intRoundTripReturn,
        origin: state.flights.requestParams.origin,
        destination: state.flights.requestParams.destination,
        cityNames: state.flights.cityNames,
        date: state.flights.departDate,
        searchId: state.flights.searchId,
        flightCode: state.flights.flightCode,
        showAgentProfit: state.ui.showAgentProfit
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetStackFlight: (flightSchedule, fareDetails, date, supplierCode, flightId, flightType) => dispatch(stackFlightActions.setStackFlight(flightSchedule, fareDetails, date, supplierCode, flightId, flightType)),
        onClearPax: () => dispatch(farePriceActions.clearPax()),
        onSetIntIds: (departId, returnId, tupleIndex) => dispatch(farePriceActions.setIntIds(departId, returnId, tupleIndex)),
        onToggleMobileFlightDetail: () => dispatch(uiActions.toggleMobileFlightDetail()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InternationalTupleRoundTrip));


// WEBPACK FOOTER //
// ./src/components/Flight/InternationalTupleRoundTrip/InternationalTupleRoundTrip.js